import { useEffect, useState } from 'react';

export const LIVEDETECT_BASE = window._env_?.REACT_APP_LIVEDETECT_URL || process.env.REACT_APP_LIVEDETECT_URL || 'https://live.railview.cadaconcepts.com/livedetect';
const POLL_LATEST_MS = 3000;
const POLL_INDEX_MS = 7000;
const STALE_THRESHOLD_S = 300;

export const bust = (url) => `${url}?t=${Date.now()}`;

export const useLatestDetection = () => {
  const [latest, setLatest] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await fetch(bust(`${LIVEDETECT_BASE}/latest.json`));
        if (cancelled) return;
        if (r.ok) {
          setLatest(await r.json());
          setError(false);
        } else {
          setLatest(null);
          setError(false);
        }
      } catch {
        if (!cancelled) setError(true);
      }
    };
    tick();
    const id = setInterval(tick, POLL_LATEST_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const nowEpoch = Date.now() / 1000;
  const isStale = latest && (nowEpoch - latest.epoch) > STALE_THRESHOLD_S;
  const isLive = !!latest && !isStale && !error;

  return { latest, error, isStale, isLive };
};

export const useDetectionIndex = () => {
  const [index, setIndex] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await fetch(bust(`${LIVEDETECT_BASE}/index.json`));
        if (cancelled) return;
        if (r.ok) setIndex(await r.json());
      } catch {
        // ignore
      }
    };
    tick();
    const id = setInterval(tick, POLL_INDEX_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return index;
};
